import React from "react";
import { Stack } from "expo-router";

/**
 * Layout component for the Design Sandbox section.
 * Provides stack navigation across component design test harnesses and workbenches.
 */
export default function DesignLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ title: "Design Sandbox" }} />
      <Stack.Screen name="design-style" options={{ title: "Style Guide" }} />
      <Stack.Screen name="themed-list-and-cards" options={{ title: "Themed List & Card Workbench" }} />
      <Stack.Screen name="themed-editor" options={{ title: "Themed Editor" }} />
      <Stack.Screen name="sharing-control" options={{ title: "Sharing Control" }} />
      <Stack.Screen name="animated-header" options={{ title: "Animated Header" }} />
      <Stack.Screen name="memory-date" options={{ title: "Memory Date" }} />
      <Stack.Screen name="date-parser" options={{ title: "Date Parser" }} />
      <Stack.Screen name="memory-filter" options={{ title: "Memory Filter" }} />
      <Stack.Screen name="media-filter" options={{ title: "Media Filter" }} />
      <Stack.Screen name="visualiser" options={{ title: "Visualiser" }} />
      <Stack.Screen name="selectors" options={{ title: "Selectors & Modals" }} />
      <Stack.Screen name="add-to-memory" options={{ title: "Add to Memory" }} />
      <Stack.Screen name="action-hover-panel" options={{ title: "Action Hover Panel" }} />
      <Stack.Screen name="symbols" options={{ title: "Platform Symbols" }} />
    </Stack>
  );
}
